import { DataSource } from "../../Data/DataSource";
import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { CheckBoxTypeEnum } from "./CheckBox";
import { CheckBoxList, CheckBoxListPropertyValues, ICheckBoxList } from "./CheckBoxList";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListYesNoPropertyValues =
    CheckBoxListPropertyValues
    & {
    };

export type CheckBoxListYesNoProperties = {
    [name in keyof CheckBoxListYesNoPropertyValues]: Property<CheckBoxListYesNoPropertyValues[name]>
};

export interface ICheckBoxListYesNo extends ICheckBoxList, CheckBoxListYesNoProperties
{
}

export class CheckBoxListYesNo extends CheckBoxList implements ICheckBoxListYesNo
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListYesNo";
    public static override className = "CheckBoxListYesNo";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CheckBoxListPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                checkBoxType: CheckBoxTypeEnum.radio,
                listDataSource: new DataSource({
                    data: [
                        { value: false, description: "No" },
                        { value: true, description: "Yes" }
                    ]
                })
            }
        };
    }

    // #endregion

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CheckBoxListYesNoPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion
}

